// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "./assets/build/main." + {"70":"cd0460311ff1208dec55","73":"cd0460311ff1208dec55","202":"cd0460311ff1208dec55","754":"cd0460311ff1208dec55"}[chunkId] + ".min.css";
};